// Ce composant sert de remplacement direct pour ValidationObserver de vee-validate v3 // Il utilise
Form de vee-validate v4 mais expose la même API
<template>
  <VeeForm v-slot="formSlot" ref="formRef" :validate-on-mount="false">
    <slot
      :handle-submit="formSlot.handleSubmit"
      :validate="validate"
      :errors="formSlot.errors"
      :meta="formSlot.meta"
      :values="formSlot.values"
      :is-submitting="formSlot.isSubmitting"
      :is-validating="formSlot.isValidating"
      :pristine="!formSlot.meta.dirty"
      :valid="formSlot.meta.valid"
    ></slot>
  </VeeForm>
</template>

<script lang="ts">
import { Form } from "vee-validate"
import { defineComponent } from "vue"
import { VeeValidateAdapter, ValidationResult } from "./vee-validate-adapter"

export default defineComponent({
  name: "ValidationObserver",
  components: {
    VeeForm: Form,
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    slim: {
      type: Boolean,
      default: false,
    },
    immediate: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // Wrapper pour maintenir la compatibilité avec l'API v3
    validate() {
      return this.validateWithInfo()
    },

    // Fonction critique utilisée dans ProjectValidationAndSaveHandler
    async validateWithInfo() {
      // @ts-ignore - Utiliser notre adaptateur
      const formRef = this.$refs.formRef as any
      if (!formRef) {
        console.error("FormRef is not available for validateWithInfo")
        return new ValidationResult(false, {})
      }
      return await VeeValidateAdapter.validateWithInfo(formRef)
    },

    // NOTE: handleSubmit n'est plus nécessaire ici car nous utilisons directement
    // formSlot.handleSubmit dans le template. Cette méthode était utilisée pour
    // maintenir la compatibilité v3, mais causait des problèmes de timing.

    // Réinitialiser le formulaire
    async reset() {
      // @ts-ignore - formRef est de type FormContext
      const formRef = this.$refs.formRef as any
      if (!formRef || typeof formRef.resetForm !== "function") {
        console.error("FormRef is not available or resetForm is not a function")
        return
      }
      await formRef.resetForm()
    },
  },
})
</script>
